/**
 * AI Visibility · marka logoları (16 Eki 2026, derma-tr + kozmetik-tr, öneri alan 510 markadan 328'i).
 * Kaynak sırası: elle seçilen → önceki set (4 Eki) → Wikidata logo kaydı (P154, Commons) → markanın sitesindeki
 * başlık logosu (Playwright ekran görüntüsü) → Commons dosya araması. Hepsi kırpıldı, düz zemin saydamlaştırıldı,
 * beyaz logolar mürekkep rengine çevrildi; dosyalar public/logos/ai/ (yükseklik 120px, saydam PNG).
 * r = en/boy oranı: components/AiBrandLogo.js bununla optik boyut eşitler (uzun logo kısalır, kare büyür).
 * Elle elenenler (yanlış marka/park alan adı/ürün fotoğrafı) üretici betiğin drop listesinde; logosu olmayan ad yazılır.
 * Anahtar = ai_visibility.brands.name.
 */
export const AI_BRAND_LOGOS = {
  "A-Derma": { src: '/logos/ai/a-derma.png', r: 3.35 },
  "Adidas": { src: '/logos/ai/adidas.png', r: 1.683 },
  "Aesop": { src: '/logos/ai/aesop.png', r: 3.175 },
  "Afnan": { src: '/logos/ai/afnan.png', r: 3.133 },
  "Akzentz": { src: '/logos/ai/akzentz.png', r: 3.442 },
  "Alima Pure": { src: '/logos/ai/alima-pure.png', r: 6.372 },
  "Alix Avien": { src: '/logos/ai/alix-avien.png', r: 6.729 },
  "Alpecin": { src: '/logos/ai/alpecin.png', r: 1.775 },
  "Alterra": { src: '/logos/ai/alterra.png', r: 4.175 },
  "American Crew": { src: '/logos/ai/american-crew.png', r: 0.942 },
  "Anastasia Beverly Hills": { src: '/logos/ai/anastasia-beverly-hills.png', r: 6.923 },
  "Armaf": { src: '/logos/ai/armaf.png', r: 1.0 },
  "Arzum": { src: '/logos/ai/arzum.png', r: 3.392 },
  "Augustinus Bader": { src: '/logos/ai/augustinus-bader.png', r: 6.207 },
  "Aveda": { src: '/logos/ai/aveda.png', r: 5.042 },
  "Aveeno": { src: '/logos/ai/aveeno.png', r: 4.383 },
  "Avon": { src: '/logos/ai/avon.png', r: 4.575 },
  "Avène": { src: '/logos/ai/avene.png', r: 2.433 },
  "Babe": { src: '/logos/ai/babe.png', r: 3.008 },
  "BaByliss": { src: '/logos/ai/babyliss.png', r: 4.158 },
  "Bade Natural": { src: '/logos/ai/bade-natural.png', r: 7.347 },
  "Balea": { src: '/logos/ai/balea.png', r: 1.692 },
  "Bargello": { src: '/logos/ai/bargello.png', r: 3.95 },
  "Bath & Body Works": { src: '/logos/ai/bath-body-works.png', r: 10.286 },
  "Batiste": { src: '/logos/ai/batiste.png', r: 1.917 },
  "Beauty of Joseon": { src: '/logos/ai/beauty-of-joseon.png', r: 10.588 },
  "Bebak": { src: '/logos/ai/bebak.png', r: 4.133 },
  "Becca": { src: '/logos/ai/becca.png', r: 4.425 },
  "Ben Nye": { src: '/logos/ai/ben-nye.png', r: 2.45 },
  "Benefit": { src: '/logos/ai/benefit.png', r: 2.992 },
  "Benzac": { src: '/logos/ai/benzac.png', r: 4.8 },
  "Bioblas": { src: '/logos/ai/bioblas.png', r: 4.633 },
  "Biodance": { src: '/logos/ai/biodance.png', r: 5.342 },
  "Bioderma": { src: '/logos/ai/bioderma.png', r: 5.0 },
  "BioMagic": { src: '/logos/ai/biomagic.png', r: 2.133 },
  "Biossance": { src: '/logos/ai/biossance.png', r: 5.883 },
  "Blistex": { src: '/logos/ai/blistex.png', r: 2.333 },
  "Bobbi Brown": { src: '/logos/ai/bobbi-brown.png', r: 8.471 },
  "Bondi Sands": { src: '/logos/ai/bondi-sands.png', r: 1.517 },
  "Born Pretty": { src: '/logos/ai/born-pretty.png', r: 1.208 },
  "Braun": { src: '/logos/ai/braun.png', r: 2.358 },
  "Bumble and bumble": { src: '/logos/ai/bumble-and-bumble.png', r: 12.414 },
  "Burberry": { src: '/logos/ai/burberry.png', r: 7.5 },
  "Burt's Bees": { src: '/logos/ai/burt-s-bees.png', r: 8.09 },
  "Byoma": { src: '/logos/ai/byoma.png', r: 4.917 },
  "Byredo": { src: '/logos/ai/byredo.png', r: 4.75 },
  "Calvin Klein": { src: '/logos/ai/calvin-klein.png', r: 6.154 },
  "Carolina Herrera": { src: '/logos/ai/carolina-herrera.png', r: 16.0 },
  "Caudalie": { src: '/logos/ai/caudalie.png', r: 3.675 },
  "Celenes": { src: '/logos/ai/celenes.png', r: 3.125 },
  "Celine": { src: '/logos/ai/celine.png', r: 4.967 },
  "CeraVe": { src: '/logos/ai/cerave.png', r: 2.817 },
  "Cetaphil": { src: '/logos/ai/cetaphil.png', r: 1.925 },
  "Chanel": { src: '/logos/ai/chanel.png', r: 6.429 },
  "Charlotte Tilbury": { src: '/logos/ai/charlotte-tilbury.png', r: 5.817 },
  "CHI": { src: '/logos/ai/chi.png', r: 2.542 },
  "Chicco": { src: '/logos/ai/chicco.png', r: 1.792 },
  "Chloé": { src: '/logos/ai/chloe.png', r: 3.242 },
  "Clarins": { src: '/logos/ai/clarins.png', r: 8.276 },
  "Clean Reserve": { src: '/logos/ai/clean-reserve.png', r: 3.5 },
  "Clinique": { src: '/logos/ai/clinique.png', r: 3.55 },
  "Clio": { src: '/logos/ai/clio.png', r: 2.65 },
  "Clé de Peau Beauté": { src: '/logos/ai/cle-de-peau-beaute.png', r: 4.25 },
  "CND": { src: '/logos/ai/cnd.png', r: 2.25 },
  "Coco & Eve": { src: '/logos/ai/coco-eve.png', r: 2.6 },
  "ColourPop": { src: '/logos/ai/colourpop.png', r: 4.317 },
  "Conair": { src: '/logos/ai/conair.png', r: 4.608 },
  "Cosmed": { src: '/logos/ai/cosmed.png', r: 3.167 },
  "Cosmelan": { src: '/logos/ai/cosmelan.png', r: 7.423 },
  "Cosrx": { src: '/logos/ai/cosrx.png', r: 4.725 },
  "Cream Co.": { src: '/logos/ai/cream-co.png', r: 9.114 },
  "Creed": { src: '/logos/ai/creed.png', r: 2.517 },
  "Dalan": { src: '/logos/ai/dalan.png', r: 3.442 },
  "Dalin": { src: '/logos/ai/dalin.png', r: 1.0 },
  "Davines": { src: '/logos/ai/davines.png', r: 2.5 },
  "Dermablend": { src: '/logos/ai/dermablend.png', r: 5.558 },
  "Dermalogica": { src: '/logos/ai/dermalogica.png', r: 9.6 },
  "Dermokil": { src: '/logos/ai/dermokil.png', r: 4.617 },
  "Dermoskin": { src: '/logos/ai/dermoskin.png', r: 9.474 },
  "Dexeryl": { src: '/logos/ai/dexeryl.png', r: 4.017 },
  "DHC": { src: '/logos/ai/dhc.png', r: 2.158 },
  "Differin": { src: '/logos/ai/differin.png', r: 3.442 },
  "Dior": { src: '/logos/ai/dior.png', r: 3.575 },
  "Diptyque": { src: '/logos/ai/diptyque.png', r: 3.242 },
  "Dolce & Gabbana": { src: '/logos/ai/dolce-gabbana.png', r: 10.141 },
  "Dr. Hauschka": { src: '/logos/ai/dr-hauschka.png', r: 1.917 },
  "Dreame": { src: '/logos/ai/dreame.png', r: 3.783 },
  "Driclor": { src: '/logos/ai/driclor.png', r: 1.983 },
  "Ducray": { src: '/logos/ai/ducray.png', r: 3.383 },
  "Dyson": { src: '/logos/ai/dyson.png', r: 2.65 },
  "e.l.f.": { src: '/logos/ai/e-l-f.png', r: 1.0 },
  "Elizabeth Arden": { src: '/logos/ai/elizabeth-arden.png', r: 5.2 },
  "Espoir": { src: '/logos/ai/espoir.png', r: 3.108 },
  "Essence": { src: '/logos/ai/essence.png', r: 2.575 },
  "Essie": { src: '/logos/ai/essie.png', r: 3.425 },
  "Estée Lauder": { src: '/logos/ai/estee-lauder.png', r: 7.912 },
  "Etat Pur": { src: '/logos/ai/etat-pur.png', r: 4.758 },
  "Eucerin": { src: '/logos/ai/eucerin.png', r: 2.467 },
  "Eveline": { src: '/logos/ai/eveline.png', r: 4.0 },
  "Eyüp Sabri Tuncer": { src: '/logos/ai/eyup-sabri-tuncer.png', r: 0.85 },
  "Fakir": { src: '/logos/ai/fakir.png', r: 2.817 },
  "Farmacy": { src: '/logos/ai/farmacy.png', r: 4.592 },
  "Filorga": { src: '/logos/ai/filorga.png', r: 2.95 },
  "First Aid Beauty": { src: '/logos/ai/first-aid-beauty.png', r: 5.9 },
  "Flormar": { src: '/logos/ai/flormar.png', r: 3.767 },
  "Gabrini": { src: '/logos/ai/gabrini.png', r: 1.867 },
  "Garnier": { src: '/logos/ai/garnier.png', r: 3.675 },
  "ghd": { src: '/logos/ai/ghd.png', r: 1.667 },
  "Gillette": { src: '/logos/ai/gillette.png', r: 4.008 },
  "Giorgio Armani Beauty": { src: '/logos/ai/giorgio-armani-beauty.png', r: 9.0 },
  "Gisou": { src: '/logos/ai/gisou.png', r: 2.208 },
  "Givenchy Beauty": { src: '/logos/ai/givenchy-beauty.png', r: 1.333 },
  "Glow Recipe": { src: '/logos/ai/glow-recipe.png', r: 10.588 },
  "Golden Rose": { src: '/logos/ai/golden-rose.png', r: 0.908 },
  "Grande Cosmetics": { src: '/logos/ai/grande-cosmetics.png', r: 6.545 },
  "Grundig": { src: '/logos/ai/grundig.png', r: 9.114 },
  "Gucci": { src: '/logos/ai/gucci.png', r: 0.958 },
  "Guerlain": { src: '/logos/ai/guerlain.png', r: 7.273 },
  "Gülsha": { src: '/logos/ai/gulsha.png', r: 2.642 },
  "Head & Shoulders": { src: '/logos/ai/head-shoulders.png', r: 2.233 },
  "Heimish": { src: '/logos/ai/heimish.png', r: 4.45 },
  "Herbal Essences": { src: '/logos/ai/herbal-essences.png', r: 1.0 },
  "Herbatint": { src: '/logos/ai/herbatint.png', r: 2.367 },
  "Himalaya": { src: '/logos/ai/himalaya.png', r: 4.6 },
  "Homemade Aromaterapi": { src: '/logos/ai/homemade-aromaterapi.png', r: 1.767 },
  "Huda Beauty": { src: '/logos/ai/huda-beauty.png', r: 5.708 },
  "Hugo Boss": { src: '/logos/ai/hugo-boss.png', r: 8.276 },
  "Ilia": { src: '/logos/ai/ilia.png', r: 2.808 },
  "Incia": { src: '/logos/ai/incia.png', r: 2.725 },
  "Inglot": { src: '/logos/ai/inglot.png', r: 2.742 },
  "INIKA Organic": { src: '/logos/ai/inika-organic.png', r: 2.225 },
  "Initio": { src: '/logos/ai/initio.png', r: 3.308 },
  "Innisfree": { src: '/logos/ai/innisfree.png', r: 7.66 },
  "iS Clinical": { src: '/logos/ai/is-clinical.png', r: 5.35 },
  "Isdin": { src: '/logos/ai/isdin.png', r: 3.2 },
  "Iva Natura": { src: '/logos/ai/iva-natura.png', r: 5.542 },
  "Jane Iredale": { src: '/logos/ai/jane-iredale.png', r: 4.425 },
  "Jean Paul Gaultier": { src: '/logos/ai/jean-paul-gaultier.png', r: 2.817 },
  "Jergens": { src: '/logos/ai/jergens.png', r: 3.283 },
  "Jo Malone London": { src: '/logos/ai/jo-malone-london.png', r: 1.742 },
  "John Frieda": { src: '/logos/ai/john-frieda.png', r: 4.225 },
  "Just For Men": { src: '/logos/ai/just-for-men.png', r: 2.742 },
  "Juvia's Place": { src: '/logos/ai/juvia-s-place.png', r: 1.892 },
  "K18": { src: '/logos/ai/k18.png', r: 1.633 },
  "Kenzo": { src: '/logos/ai/kenzo.png', r: 4.067 },
  "Kiehl's": { src: '/logos/ai/kiehl-s.png', r: 3.75 },
  "Kiko Milano": { src: '/logos/ai/kiko-milano.png', r: 2.783 },
  "Kilian Paris": { src: '/logos/ai/kilian-paris.png', r: 1.642 },
  "Kiss": { src: '/logos/ai/kiss.png', r: 3.767 },
  "Kjaer Weis": { src: '/logos/ai/kjaer-weis.png', r: 4.3 },
  "Klairs": { src: '/logos/ai/klairs.png', r: 2.358 },
  "Klorane": { src: '/logos/ai/klorane.png', r: 5.6 },
  "Kodi Professional": { src: '/logos/ai/kodi-professional.png', r: 6.857 },
  "Kose": { src: '/logos/ai/kose.png', r: 1.217 },
  "Kryolan": { src: '/logos/ai/kryolan.png', r: 7.826 },
  "KVD Beauty": { src: '/logos/ai/kvd-beauty.png', r: 1.108 },
  "Kérastase": { src: '/logos/ai/kerastase.png', r: 3.433 },
  "L'Artisan Parfumeur": { src: '/logos/ai/l-artisan-parfumeur.png', r: 19.459 },
  "L'Occitane": { src: '/logos/ai/l-occitane.png', r: 4.517 },
  "L'Oréal Paris": { src: '/logos/ai/l-oreal-paris.png', r: 5.517 },
  "L'Oréal Professionnel": { src: '/logos/ai/l-oreal-professionnel.png', r: 2.583 },
  "La Mer": { src: '/logos/ai/la-mer.png', r: 0.792 },
  "La Prairie": { src: '/logos/ai/la-prairie.png', r: 4.15 },
  "La Roche-Posay": { src: '/logos/ai/la-roche-posay.png', r: 3.925 },
  "Lalique": { src: '/logos/ai/lalique.png', r: 2.475 },
  "Lancôme": { src: '/logos/ai/lancome.png', r: 4.125 },
  "Latisse": { src: '/logos/ai/latisse.png', r: 2.708 },
  "Lattafa": { src: '/logos/ai/lattafa.png', r: 0.758 },
  "Le Labo": { src: '/logos/ai/le-labo.png', r: 3.542 },
  "Loewe": { src: '/logos/ai/loewe.png', r: 4.4 },
  "Loris": { src: '/logos/ai/loris.png', r: 3.4 },
  "Louis Vuitton": { src: '/logos/ai/louis-vuitton.png', r: 0.825 },
  "Loving Tan": { src: '/logos/ai/loving-tan.png', r: 3.075 },
  "Lush": { src: '/logos/ai/lush.png', r: 2.3 },
  "MAC": { src: '/logos/ai/mac.png', r: 9.231 },
  "MAD Parfüm": { src: '/logos/ai/mad-parfum.png', r: 1.933 },
  "Maison Crivelli": { src: '/logos/ai/maison-crivelli.png', r: 8.889 },
  "Maison Margiela": { src: '/logos/ai/maison-margiela.png', r: 4.775 },
  "Make Up For Ever": { src: '/logos/ai/make-up-for-ever.png', r: 2.158 },
  "Makeup by Mario": { src: '/logos/ai/makeup-by-mario.png', r: 7.826 },
  "Mancera": { src: '/logos/ai/mancera.png', r: 4.7 },
  "Manucurist": { src: '/logos/ai/manucurist.png', r: 4.317 },
  "Marc Anthony": { src: '/logos/ai/marc-anthony.png', r: 6.261 },
  "Marc Jacobs": { src: '/logos/ai/marc-jacobs.png', r: 15.319 },
  "Maruderm": { src: '/logos/ai/maruderm.png', r: 5.083 },
  "Matière Première": { src: '/logos/ai/matiere-premiere.png', r: 3.075 },
  "Mavala": { src: '/logos/ai/mavala.png', r: 4.592 },
  "Maybelline": { src: '/logos/ai/maybelline.png', r: 6.667 },
  "Medicube": { src: '/logos/ai/medicube.png', r: 2.833 },
  "Medik8": { src: '/logos/ai/medik8.png', r: 4.333 },
  "Memo Paris": { src: '/logos/ai/memo-paris.png', r: 1.4 },
  "Merit": { src: '/logos/ai/merit.png', r: 6.729 },
  "Mesoestetic": { src: '/logos/ai/mesoestetic.png', r: 7.423 },
  "Michael Kors": { src: '/logos/ai/michael-kors.png', r: 10.588 },
  "Milani": { src: '/logos/ai/milani.png', r: 4.483 },
  "Mineral Fusion": { src: '/logos/ai/mineral-fusion.png', r: 3.025 },
  "Missha": { src: '/logos/ai/missha.png', r: 5.383 },
  "Mizon": { src: '/logos/ai/mizon.png', r: 2.775 },
  "Molton Brown": { src: '/logos/ai/molton-brown.png', r: 10.286 },
  "Montale": { src: '/logos/ai/montale.png', r: 7.66 },
  "Montblanc": { src: '/logos/ai/montblanc.png', r: 1.833 },
  "Moroccanoil": { src: '/logos/ai/moroccanoil.png', r: 12.414 },
  "Morphe": { src: '/logos/ai/morphe.png', r: 8.471 },
  "Mustela": { src: '/logos/ai/mustela.png', r: 3.133 },
  "Nair": { src: '/logos/ai/nair.png', r: 1.775 },
  "Narciso Rodriguez": { src: '/logos/ai/narciso-rodriguez.png', r: 13.333 },
  "NARS": { src: '/logos/ai/nars.png', r: 2.375 },
  "Nascita": { src: '/logos/ai/nascita.png', r: 2.708 },
  "Native": { src: '/logos/ai/native.png', r: 3.2 },
  "Nautica": { src: '/logos/ai/nautica.png', r: 7.129 },
  "Neostrata": { src: '/logos/ai/neostrata.png', r: 4.658 },
  "NeoStrata": { src: '/logos/ai/neostrata.png', r: 4.658 },
  "Neutrogena": { src: '/logos/ai/neutrogena.png', r: 4.75 },
  "New Well": { src: '/logos/ai/new-well.png', r: 5.275 },
  "Nivea": { src: '/logos/ai/nivea.png', r: 1.0 },
  "Nizoral": { src: '/logos/ai/nizoral.png', r: 2.425 },
  "Note": { src: '/logos/ai/note.png', r: 5.033 },
  "Nuxe": { src: '/logos/ai/nuxe.png', r: 6.792 },
  "NYX": { src: '/logos/ai/nyx.png', r: 3.508 },
  "Obagi": { src: '/logos/ai/obagi.png', r: 2.5 },
  "Ohora": { src: '/logos/ai/ohora.png', r: 3.083 },
  "Olaplex": { src: '/logos/ai/olaplex.png', r: 6.05 },
  "Olay": { src: '/logos/ai/olay.png', r: 3.467 },
  "Old Spice": { src: '/logos/ai/old-spice.png', r: 3.45 },
  "Ole Henriksen": { src: '/logos/ai/ole-henriksen.png', r: 11.077 },
  "ONE/SIZE": { src: '/logos/ai/one-size.png', r: 7.742 },
  "OPI": { src: '/logos/ai/opi.png', r: 3.183 },
  "Oribe": { src: '/logos/ai/oribe.png', r: 3.2 },
  "Oriflame": { src: '/logos/ai/oriflame.png', r: 5.258 },
  "Origani": { src: '/logos/ai/origani.png', r: 2.125 },
  "OSiS": { src: '/logos/ai/osis.png', r: 3.083 },
  "Ouai": { src: '/logos/ai/ouai.png', r: 3.333 },
  "Palmolive": { src: '/logos/ai/palmolive.png', r: 4.2 },
  "Pantene": { src: '/logos/ai/pantene.png', r: 5.592 },
  "Parfums de Marly": { src: '/logos/ai/parfums-de-marly.png', r: 7.912 },
  "Paula's Choice": { src: '/logos/ai/paula-s-choice.png', r: 13.846 },
  "Peter Thomas Roth": { src: '/logos/ai/peter-thomas-roth.png', r: 8.889 },
  "Pharmaceris": { src: '/logos/ai/pharmaceris.png', r: 3.1 },
  "Philips": { src: '/logos/ai/philips.png', r: 0.758 },
  "Philosophy": { src: '/logos/ai/philosophy.png', r: 4.175 },
  "Physicians Formula": { src: '/logos/ai/physicians-formula.png', r: 3.417 },
  "Pierre Cardin": { src: '/logos/ai/pierre-cardin.png', r: 6.261 },
  "Polente Natural": { src: '/logos/ai/polente-natural.png', r: 1.525 },
  "Proraso": { src: '/logos/ai/proraso.png', r: 1.683 },
  "Rabanne": { src: '/logos/ai/rabanne.png', r: 5.717 },
  "Rasasi": { src: '/logos/ai/rasasi.png', r: 2.45 },
  "Redken": { src: '/logos/ai/redken.png', r: 3.783 },
  "Remington": { src: '/logos/ai/remington.png', r: 6.316 },
  "RevitaLash": { src: '/logos/ai/revitalash.png', r: 5.0 },
  "Revlon": { src: '/logos/ai/revlon.png', r: 6.0 },
  "Revox": { src: '/logos/ai/revox.png', r: 4.042 },
  "Rexona": { src: '/logos/ai/rexona.png', r: 1.017 },
  "Rimmel": { src: '/logos/ai/rimmel.png', r: 6.154 },
  "Rituals": { src: '/logos/ai/rituals.png', r: 1.05 },
  "RMS Beauty": { src: '/logos/ai/rms-beauty.png', r: 2.8 },
  "Rosece": { src: '/logos/ai/rosece.png', r: 1.492 },
  "Rosense": { src: '/logos/ai/rosense.png', r: 2.0 },
  "Round Lab": { src: '/logos/ai/round-lab.png', r: 10.141 },
  "Rovectin": { src: '/logos/ai/rovectin.png', r: 3.867 },
  "Saie": { src: '/logos/ai/saie.png', r: 1.0 },
  "Sally Hansen": { src: '/logos/ai/sally-hansen.png', r: 3.025 },
  "Schwarzkopf": { src: '/logos/ai/schwarzkopf.png', r: 1.458 },
  "Sebamed": { src: '/logos/ai/sebamed.png', r: 1.517 },
  "Secret": { src: '/logos/ai/secret.png', r: 2.042 },
  "Sesderma": { src: '/logos/ai/sesderma.png', r: 3.033 },
  "Shark": { src: '/logos/ai/shark.png', r: 3.875 },
  "Shiseido": { src: '/logos/ai/shiseido.png', r: 6.0 },
  "Sisley": { src: '/logos/ai/sisley.png', r: 3.408 },
  "Siveno": { src: '/logos/ai/siveno.png', r: 3.967 },
  "SK-II": { src: '/logos/ai/sk-ii.png', r: 2.317 },
  "Skin1004": { src: '/logos/ai/skin1004.png', r: 12.414 },
  "Skin401": { src: '/logos/ai/skin401.png', r: 3.092 },
  "SkinCeuticals": { src: '/logos/ai/skinceuticals.png', r: 11.077 },
  "Skinfood": { src: '/logos/ai/skinfood.png', r: 3.925 },
  "Slazenger": { src: '/logos/ai/slazenger.png', r: 4.85 },
  "Sleepy": { src: '/logos/ai/sleepy.png', r: 1.967 },
  "Sol de Janeiro": { src: '/logos/ai/sol-de-janeiro.png', r: 7.5 },
  "Solante": { src: '/logos/ai/solante.png', r: 3.233 },
  "Some By Mi": { src: '/logos/ai/some-by-mi.png', r: 7.273 },
  "St. Tropez": { src: '/logos/ai/st-tropez.png', r: 1.608 },
  "Sudocrem": { src: '/logos/ai/sudocrem.png', r: 4.875 },
  "Sulwhasoo": { src: '/logos/ai/sulwhasoo.png', r: 5.183 },
  "Summer Fridays": { src: '/logos/ai/summer-fridays.png', r: 13.091 },
  "Sunday Riley": { src: '/logos/ai/sunday-riley.png', r: 3.825 },
  "Tarte": { src: '/logos/ai/tarte.png', r: 3.158 },
  "Tatcha": { src: '/logos/ai/tatcha.png', r: 9.73 },
  "Thalia": { src: '/logos/ai/thalia.png', r: 1.617 },
  "Thayers": { src: '/logos/ai/thayers.png', r: 4.108 },
  "The Inkey List": { src: '/logos/ai/the-inkey-list.png', r: 10.0 },
  "The Ordinary": { src: '/logos/ai/the-ordinary.png', r: 2.783 },
  "The Purest Solutions": { src: '/logos/ai/the-purest-solutions.png', r: 1.7 },
  "Thrive Causemetics": { src: '/logos/ai/thrive-causemetics.png', r: 2.175 },
  "Tirtir": { src: '/logos/ai/tirtir.png', r: 5.558 },
  "TNL Professional": { src: '/logos/ai/tnl-professional.png', r: 2.85 },
  "Tom Ford Beauty": { src: '/logos/ai/tom-ford-beauty.png', r: 6.606 },
  "Toni&Guy": { src: '/logos/ai/toni-guy.png', r: 6.429 },
  "Too Faced": { src: '/logos/ai/too-faced.png', r: 1.467 },
  "Topicrem": { src: '/logos/ai/topicrem.png', r: 4.542 },
  "Tower 28": { src: '/logos/ai/tower-28.png', r: 5.025 },
  "TRESemmé": { src: '/logos/ai/tresemme.png', r: 2.775 },
  "Uni Baby": { src: '/logos/ai/uni-baby.png', r: 1.342 },
  "Urban Care": { src: '/logos/ai/urban-care.png', r: 4.475 },
  "Urban Decay": { src: '/logos/ai/urban-decay.png', r: 3.458 },
  "Uriage": { src: '/logos/ai/uriage.png', r: 3.217 },
  "Valmont": { src: '/logos/ai/valmont.png', r: 6.102 },
  "Vanicream": { src: '/logos/ai/vanicream.png', r: 4.142 },
  "Vaseline": { src: '/logos/ai/vaseline.png', r: 1.475 },
  "Veela": { src: '/logos/ai/veela.png', r: 2.942 },
  "Veet": { src: '/logos/ai/veet.png', r: 1.0 },
  "Venalisa": { src: '/logos/ai/venalisa.png', r: 4.25 },
  "Versace": { src: '/logos/ai/versace.png', r: 4.508 },
  "Vichy": { src: '/logos/ai/vichy.png', r: 3.375 },
  "Victoria Beckham Beauty": { src: '/logos/ai/victoria-beckham-beauty.png', r: 13.585 },
  "Victoria's Secret": { src: '/logos/ai/victoria-s-secret.png', r: 12.0 },
  "Viktor&Rolf": { src: '/logos/ai/viktor-rolf.png', r: 9.0 },
  "Viseart": { src: '/logos/ai/viseart.png', r: 15.0 },
  "Weleda": { src: '/logos/ai/weleda.png', r: 5.433 },
  "Wella Professionals": { src: '/logos/ai/wella-professionals.png', r: 1.583 },
  "Westman Atelier": { src: '/logos/ai/westman-atelier.png', r: 16.744 },
  "Wet n Wild": { src: '/logos/ai/wet-n-wild.png', r: 6.102 },
  "Wilkinson Sword": { src: '/logos/ai/wilkinson-sword.png', r: 4.275 },
  "Xerjoff": { src: '/logos/ai/xerjoff.png', r: 5.85 },
  "Yves Rocher": { src: '/logos/ai/yves-rocher.png', r: 5.125 },
  "Yves Saint Laurent Beauty": { src: '/logos/ai/yves-saint-laurent-beauty.png', r: 10.141 },
  "Zadig & Voltaire": { src: '/logos/ai/zadig-voltaire.png', r: 6.261 },
  "Zara": { src: '/logos/ai/zara.png', r: 2.375 },
  "ZO Skin Health": { src: '/logos/ai/zo-skin-health.png', r: 5.433 },
  "Zoya": { src: '/logos/ai/zoya.png', r: 6.545 },
};

export const brandLogoInfo = (name) => AI_BRAND_LOGOS[name] || null;
export const brandLogo = (name) => AI_BRAND_LOGOS[name]?.src || null;
